import React from 'react';
import styles from './input.module.css';

class InputMail extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: this.props.value }
  }

  handleValue = (e) => {
    this.setState({value: e.target.value});
  }

  handleValidate = (e) => {
    let val;
    let required;
    let errorMessage;
    let mailMask;
    let underInput;
    val = e.target.value;
    required = e.target.getAttribute("data-required");
    mailMask = /^([_a-zA-Z0-9-]+)(\.[_a-zA-Z0-9-]+)*@([a-zA-Z0-9-]+\.)+([a-zA-Z]{2,3})$/;
    if(this.props.underinput) {
      underInput = this.props.underinput
    }
    else {
      underInput = ''
    }

    if ((required === "true") && val.length < 1) {
      e.target.className += " invalid-input";
      errorMessage = "<span class='error-message'>Обязательное поле</span>";
      e.target.nextSibling.innerHTML = errorMessage;
    }
    else {
      if(!mailMask.test(val)) {
        e.target.className += " invalid-input";
        errorMessage = "<span class='error-message'>Неверный формат email</span>";
        e.target.nextSibling.innerHTML = errorMessage;
      }
      else {
        e.target.classList.remove("invalid-input");
        e.target.nextSibling.innerText = underInput;
      }
    }
  }

  render() {
    return (
      <div>
        <div className={styles.label}>{this.props.label}</div>
        <input type="email" className={`${styles.input} ${this.props.className}`}
               onChange={this.handleValue}
               value={this.state.value}
               onInput={this.handleValidate} id={this.props.id}
               name={this.props.name} placeholder={this.props.placeholder}
               maxLength={this.props.maxlength} data-error={this.props.error}
               data-required={this.props.required} disabled={this.props.disabled}
               onBlur={this.props.onChange}
        />
        <div className={styles.underinput}>{this.props.underinput}</div>
      </div>
    )
  }
}

export default InputMail;